import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { usePCrmServiceCategorys, PCrmServiceCategory } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<PCrmServiceCategory>
      useData={usePCrmServiceCategorys}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
